import './prototypes';
import { WbScrollTo } from './modules/WbScrollTo';
import { WbBarbaController } from './modules/WbBarbaController';
import { WbPrintController } from './modules/WbPrintController';
import { WbGravityFormsRenderer } from './modules/WbGravityFormsRenderer';
import { WbBackToTop } from './modules/WbBackToTop';
import { WbSearchController } from './modules/WbSearchController';
import { WbSearchOverlay } from './modules/WbSearchOverlay';
import { WbMasthead } from './modules/WbMasthead';
import { WbHeaderNotification } from './modules/WbHeaderNotification';
import { WbSocialShare } from './modules/WbSocialShare';
import { WpBlockGallery } from './modules/WpBlockGallery';
import { WbAnimations } from './modules/WbAnimations';

document.addEventListener('readystatechange', (event) => {
  if (document.readyState == 'complete') {
    /**
     * ALL OF THESE ARE GLOBALS
     * DO NOT IMPORT IN A DIFFERENT MODULE
     */
    window.WbBarbaController = new WbBarbaController();
    window.WbScrollTo = new WbScrollTo();
    window.WbPrintController = new WbPrintController();
    window.WbBackToTop = new WbBackToTop();
    window.WbSearchController = new WbSearchController();
    window.WbSearchOverlay = new WbSearchOverlay();
    window.WbHeaderNotification = new WbHeaderNotification();
    window.WbMasthead = new WbMasthead();
    window.WbAnimations = new WbAnimations();

    window.WbBarbaController.addObject(window.WbScrollTo);
    window.WbBarbaController.addObject(window.WbHeaderNotification);
    window.WbBarbaController.addObject(new WpBlockGallery());
    window.WbBarbaController.addObject(new WbGravityFormsRenderer());
    window.WbBarbaController.addObject(new WbSocialShare());
    window.WbBarbaController.init();
  }
});
